import React from 'react';

export function ChevronUp () {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.6875 7.95374L6.22084 3.48748V3.48748C6.09905 3.36552 5.90145 3.36538 5.77948 3.48717C5.77938 3.48728 5.77927 3.48738 5.77917 3.48748L1.3125 7.95374"
        stroke="#071C3E"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

  );
}
